import React, { PropsWithChildren } from 'react'

export const MenuItemWarning = ({ children }: PropsWithChildren) => {
  return (
    <div className="rounded-lg border border-warning-500 bg-bgWarning p-3">
      <p className="text-M text-warning-600">{children}</p>
    </div>
  )
}
